import { toFormat } from "@/lib/dateHelpers";

export type HighestLevelOfEducation = "high_school_or_ged" | "associate_degree" | "bachelors_or_higher";

export const HIGHEST_LEVEL_OF_EDUCATION_LABELS: Record<HighestLevelOfEducation, string> = {
  high_school_or_ged: "High school diploma or GED",
  associate_degree: "Associate degree",
  bachelors_or_higher: "Bachelor's degree or higher"
};

export const HIGHEST_LEVEL_OF_EDUCATION_OPTIONS: { value: HighestLevelOfEducation; label: string }[] = (
  Object.keys(HIGHEST_LEVEL_OF_EDUCATION_LABELS) as HighestLevelOfEducation[]
).map((value) => ({ value, label: HIGHEST_LEVEL_OF_EDUCATION_LABELS[value] }));

export const GRADUATION_MONTH_OPTIONS = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" }
] as const;

const EARLIEST_GRADUATION_YEAR = 1950;

function buildGraduationYearOptions(): Array<{ label: string; value: string }> {
  const currentYear = new Date().getFullYear();
  const years: Array<{ label: string; value: string }> = [];

  for (let year = currentYear; year >= EARLIEST_GRADUATION_YEAR; year -= 1) {
    const value = String(year);
    years.push({ label: value, value });
  }

  return years;
}

export const GRADUATION_YEAR_OPTIONS = buildGraduationYearOptions();

export function formatHighestLevelOfEducation(value: HighestLevelOfEducation | null | undefined): string | null {
  if (!value) return null;
  return HIGHEST_LEVEL_OF_EDUCATION_LABELS[value];
}

export function formatGraduationDate(
  graduationMonth: string | null | undefined,
  graduationYear: string | null | undefined
): string | null {
  if (!graduationMonth || !graduationYear) return null;

  const month = Number.parseInt(graduationMonth, 10);
  const year = Number.parseInt(graduationYear, 10);
  if (Number.isNaN(month) || Number.isNaN(year) || month < 1 || month > 12) return null;

  const formatted = toFormat(`${year}-${String(month).padStart(2, "0")}-01`, "LLL yyyy");
  return formatted || null;
}
